export default "__VITE_ASSET__9ClvTrpm__"